/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


import {UserDetailsRes} from "./user.contract";
import {Type} from 'class-transformer';

export class LoginReq {
    email: string ="";
    password: string ="";
}

export class ChangePasswordReq {
    email!: string;
    currentPassword!: string | null;
    newPassword!: string;
    newPasswordConfirm!: string;
}


export class LoginRes {
    token!: string;
    refreshToken?: string;
    passwordExpired!: boolean;

    @Type(() => UserDetailsRes)
    user!: UserDetailsRes;
}
